import { bulletinService } from '../services/bulletins.service';

const state = {
  all: {}
};

const actions = {
  async getAll({ dispatch, commit }) {
    commit('getBulletinsSuccess', await bulletinService.getBulletins());
  }
};

const mutations = {
  getBulletinsSuccess(state, bulletins) {
    state.all = bulletins;
  }
};

export const bulletins = {
  namespaced: true,
  state,
  actions,
  mutations
};
